module.exports = __webpack_public_path__ + "static/media/dd-arrow.bbe49c28.svg";